import { dateToLocalDateString } from "@/shared/lib/date-format";
import {
  FISCAL_DOCUMENT_TYPE,
  type FiscalDocumentType,
} from "./types/fiscal-export.types";

export const MAX_PERIOD_DAYS = 366;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export interface PeriodRange {
  startDate: string;
  endDate: string;
}

export interface PeriodPreset {
  id: string;
  label: string;
  resolve: () => PeriodRange;
}

export const PERIOD_PRESETS: PeriodPreset[] = [
  {
    id: "last-month",
    label: "Mês passado",
    resolve: () => {
      const now = new Date();
      return {
        startDate: dateToLocalDateString(
          new Date(now.getFullYear(), now.getMonth() - 1, 1),
        ),
        endDate: dateToLocalDateString(
          new Date(now.getFullYear(), now.getMonth(), 0),
        ),
      };
    },
  },
  {
    id: "this-month",
    label: "Este mês",
    resolve: () => {
      const now = new Date();
      return {
        startDate: dateToLocalDateString(
          new Date(now.getFullYear(), now.getMonth(), 1),
        ),
        endDate: dateToLocalDateString(now),
      };
    },
  },
  {
    id: "last-30-days",
    label: "Últimos 30 dias",
    resolve: () => {
      const now = new Date();
      return {
        startDate: dateToLocalDateString(
          new Date(now.getTime() - 29 * MS_PER_DAY),
        ),
        endDate: dateToLocalDateString(now),
      };
    },
  },
  {
    id: "this-year",
    label: "Este ano",
    resolve: () => {
      const now = new Date();
      return {
        startDate: dateToLocalDateString(new Date(now.getFullYear(), 0, 1)),
        endDate: dateToLocalDateString(now),
      };
    },
  },
];

export const DOCUMENT_TYPE_OPTIONS: Array<{
  type: FiscalDocumentType;
  label: string;
  description: string;
  folder: string;
}> = [
  {
    type: FISCAL_DOCUMENT_TYPE.NFSE,
    label: "Notas Fiscais",
    description: "NFS-e de serviço, emitidas por aluguéis e formaturas.",
    folder: "nfse/",
  },
  {
    type: FISCAL_DOCUMENT_TYPE.NFCE,
    label: "Notas Comerciais",
    description: "NFC-e de consumidor, emitidas avulsas no balcão.",
    folder: "nfce/",
  },
];

export function countDaysInRange(startDate: string, endDate: string): number {
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(`${endDate}T00:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return 0;
  return Math.round((end.getTime() - start.getTime()) / MS_PER_DAY) + 1;
}

export function formatPeriodLabel(startDate: string, endDate: string): string {
  const toBr = (value: string) => value.split("-").reverse().join("/");
  return `${toBr(startDate)} a ${toBr(endDate)}`;
}
